<template>
  <el-dialog
    :visible="true"
    width="90%"
    :show-close="false"
    :close-on-click-modal="false"
    class="detail-page"
    @close="shutDown"
  >
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        label="序号"
        width="50px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        prop="signHoldDate"
        label="成交日期"
      />
      <af-table-column
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="sumHoldAmount"
        label="总订货量"
      />
      <af-table-column
        prop="netHoldAmount"
        label="净订货量"
      />
      <af-table-column
        prop="buyHoldAmount"
        label="采购订货量"
      />
      <af-table-column
        prop="buyAvgPrice"
        label="采购均价"
      />
      <af-table-column
        prop="buyFrozenBailBalance"
        label="基本担保履约资金(采购)"
      />
      <af-table-column
        prop="buyHoldGainLoss"
        label="补充担保履约资金(采购)"
      />
      <af-table-column
        prop="buyFrozenAmount"
        label="采购冻结量"
      />
      <af-table-column
        prop="buyLockedAmount"
        label="采购锁单量"
      />
      <af-table-column
        prop="sellHoldAmount"
        label="销售订货量"
      />
      <af-table-column
        prop="sellAvgPrice"
        label="销售均价"
      />
      <af-table-column
        prop="sellFrozenBailBalance"
        label="基本担保履约资金(销售)"
      />
      <af-table-column
        prop="sellHoldGainLoss"
        label="补充担保履约资金(销售)"
      />
      <af-table-column
        prop="sellFrozenAmount"
        label="销售冻结量"
      />
      <af-table-column
        prop="sellLockedAmount"
        label="销售锁单量"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
    <div class="detailPage-btns">
      <el-button
        type="primary"
        @click="toDownload"
      >
        导出
      </el-button>
      <el-button @click="shutDown">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import api from '@/api'

export default {
  name: 'Detail',
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        // goodsCode: this.row.goodsCode, // 购销计划代码
        areaId: this.row.areaId, // 区域ID
        signHoldDate: this.row.signHoldDate, // 日期
        marketId: this.row.marketId, // 市场id
        type: 'T', // P为普通，T为套利
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let res = await api.spotPurchaseSaleInquiry.OrderXQ(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
    },
    // 关闭弹窗
    shutDown () {
      this.$emit('shutDown')
    },
    // 导出
    toDownload () {
      let param = {
        areaId: this.row.areaId, // 区域ID
        signHoldDate: this.row.signHoldDate, // 日期
        marketId: this.row.marketId, // 市场id
        type: 'T', // P为普通，T为套利
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        exportType: 'queryPositionDetail4T',
      }
      this.$utils.getExcelFile(this, api.detail, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
